import React from 'react';
import { PictureInPictureProps, PIPIcon, PIPIconType } from './pictureInPicture.types';
import { inject, observer } from 'mobx-react';

import classNames from 'classnames';
import styles from './pictureInPicture.scss';

export const PictureInPicture = inject('mixedMediaStore')(observer(function PictureInPicture({
    mixedMediaStore,
    children
}: PictureInPictureProps) {
    if (!children) {
        return;
    }

    const PIPFeatureToggleEnabled = mixedMediaStore.mainStore.dataStore.contextData.featureToggles.enablePictureInPicture;
    if (!mixedMediaStore || !mixedMediaStore.mainImageIcons || !PIPFeatureToggleEnabled) {
        return <>{children}</>
    }

    const { legalIcons, marketingIcons } = sortPIPIcons(mixedMediaStore.mainImageIcons);
    const renderIconGroup = (icons: PIPIcon[], iconsType: PIPIconType) => {
        if (!icons.length) {
            return;
        }

        return (
            <div className={classNames(
                styles.pip_icon_group,
                {
                    [styles.pip_icon_group_legal]: iconsType === PIPIconType.Legal,
                    [styles.pip_icon_group_marketing]: iconsType === PIPIconType.Marketing
                }   
            )}>
                { icons.map((icon, i) => {
                    return (
                        <img
                            className={styles.pip_icon}
                            key={`${icon.type}-${i}`}
                            src={icon.imageUrl}
                            alt={icon.imageAltTag}
                        />
                    )
                })}
            </div>
        )
    }

    if (!legalIcons.length && !marketingIcons.length) {
        return <>{children}</>
    }

    return (
        <div className={styles.pip_icon_container}>
            {children}

            {legalIcons && renderIconGroup(legalIcons, PIPIconType.Legal)}
            {marketingIcons && renderIconGroup(marketingIcons, PIPIconType.Marketing)}
        </div>
    );
}));

function sortPIPIcons(
    icons: PIPIcon[]
): { legalIcons: PIPIcon[], marketingIcons: PIPIcon[] } {
    const legal: PIPIcon[] = [];
    const marketing:  PIPIcon[] = [];

    icons.forEach((icon) => {
        if (icon.type === PIPIconType.Legal) {
            legal.push(icon);
        }
        else if (icon.type === PIPIconType.Marketing) {
            marketing.push(icon);
        }
        else {
            // Unexpected PIP icon type received
        }
    });

    return {
        legalIcons: legal,
        marketingIcons: marketing
    }
}
